import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const Auth = ({ children }) => {
  const [loggedin, setLoggedin] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const isAuthenticated = () => {
    const token = secureLocalStorage.getItem("token");
    if (token && id != "undefined") {
      setLoggedin(true);
    } else {
      navigate("/signin");
    }
    return false;
  };
  useEffect(() => {
    isAuthenticated();
  });
  return <>{loggedin ? <div>{children}</div> : <>{"Loading"}</>}</>;
};
export default Auth;
